import { Section, Eyebrow } from "./Section"

export function Mechanism() {
  return (
    <Section className="bg-surface">
      <div className="mx-auto max-w-3xl text-center">
        <Eyebrow>The shift</Eyebrow>
        <h2 className="display-2 mt-4">
          The podcast is not the product. The conversation is.
        </h2>
        <p className="mt-6 text-lg text-ink-body">
          The right podcast gives you a reason to start meaningful conversations
          with people already connected to your market: future clients, referral
          partners, collaborators, industry peers, and credibility partners.
        </p>
        <p className="mt-4 text-ink-muted">
          FullCast helps turn those conversations into polished weekly episodes,
          useful content, and long-term relationship assets. The goal isn't to
          chase downloads — it's to build a show that earns trust before the sales
          call, deepens your authority, and gives you a repeatable reason to
          connect with better-fit people.
        </p>
      </div>
    </Section>
  )
}
